<template>
  <span class="action-icon right-arrow">
    <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" :opacity="opacity">
        <g id="Desktop-HD-Copy-7" transform="translate(-1249.000000, -35.000000)" :fill="fill">
          <g id="Group-3" transform="translate(1234.800000, 19.700000)">
            <polygon id="Shape-Copy" transform="translate(22.000000, 22.636789) rotate(-180.000000) translate(-22.000000, -22.636789) " points="29 21.7617887 18.325 21.7617887 23.225 16.8617887 22 15.6367887 15 22.6367887 22 29.6367887 23.225 28.4117887 18.325 23.5117887 29 23.5117887"></polygon>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<style lang="less"scoped>
  svg {
    vertical-align: middle;
  }
</style>

<script>
  export default {
    props: {
      opacity: {
        type: Number,
        default: 0.5
      },
      fill: {
        type: String,
        default: "#000000"
      }
    }
  }
</script>